import moment from "moment";
import React from "react";

export default function LoginHistoryCard(props) {
  const item = props.item;
  return (
    <div className="menuContainer addHight text">
      <div className="menuExchange large">{item.ip == null ? "NO IP" : item.ip}</div>
      <div className="menuSymbol small">
        {" "}
        {item.deviceid == null ? "NO DEVICE ID" : item.deviceid}
      </div>
      <div className="menuSymbol large">
        {" "}
        {item.device == null ? "NO DEVICE" : item.device}
      </div>
      <div className="menuLtt large">
        {item.login_date == null ? "-" : moment(item.login_date).format("DD-MM-YYYY HH:mm:ss")}
      </div>
      <div className="menuLtt large">
        {item.logout_date == null ? "-" : moment(item.logout_date).format("DD-MM-YYYY HH:mm:ss")}
      </div>
      <div className="menuLtt large">
        {moment(item.date_created).format("DD-MM-YYYY HH:mm:ss")}
      </div>
    </div>
  );
}
